import axios from "axios";

// If your app already has axios baseURL set, keep relative URLs.
// Only absolute URLs are used when required.

export const inviteAgencyApi = {
  getAgencyDetails(agency_profile_id) {
    return axios.get(
      `/api/get-agency-details-from-inviteagency?agency_profile_id=${encodeURIComponent(
        agency_profile_id
      )}`
    );
  },

  getUserDetails(user_profile_id) {
    return axios.get(
      `/api/get-user-details-from-inviteagency?user_profile_id=${encodeURIComponent(
        user_profile_id
      )}`
    );
  },

  sendOtp(user_profile_id) {
    return axios.post("https://starmate.co.in/api/send-otp-from-inviteagency", {
      user_profile_id,
    });
  },

  updateUserFromInviteAgency({ agency_profile_id, user_profile_id, mobile, otp }) {
    return axios.post("https://starmate.co.in/api/update-user-from-inviteagency", {
      agency_profile_id,
      user_profile_id,
      mobile,
      otp,
    });
  },
};
